export default {
  setMemoryState(state, payload) {
    state.memory = payload;
  },
  setSubmittedMemoryState(state, payload) {
    state.submittedMemory = payload;
  },
  setMemoryLoadingState(state, payload) {
    state.memoryLoading = payload;
  },
  setMemorySubmitLoadingState(state, payload) {
    state.submitLoading = payload;
  },
};
